import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { Children, cloneElement, Component } from 'react';
import { findDOMNode } from 'react-dom';
import onClickOutside from 'react-onclickoutside-decorator';
import { ListBox } from '../../../organisms/ListBox';
import { getOffsetHeight, getTop } from '../../../utils/dimensions';
class SelectList extends Component {
    static displayName = 'SelectList';
    componentDidUpdate(nextProps) {
        const { focusedIndex, selectedIndex, searchText, style } = this.props;
        if (nextProps.focusedIndex !== focusedIndex || nextProps.selectedIndex !== selectedIndex || nextProps.searchText !== searchText) {
            this.adjustScrollToView();
        } else if (nextProps.style.opacity !== style.opacity) {
            this.scrollToTopOfSelected(style.opacity);
        }
    }
    scrollToTopOfSelected(scale) {
        const focused = findDOMNode(this._focused);
        const root = findDOMNode(this._root);
        if (focused && root) {
            const focusTop = getTop(focused);
            const rootTop = getTop(root);
            const diffTop = focusTop - rootTop;
            if (diffTop > 0) {
                root.scrollTop += diffTop * scale;
            }
        }
    }
    adjustScrollToView() {
        const focused = findDOMNode(this._focused);
        const root = findDOMNode(this._root);
        if (focused && root) {
            const focusTop = getTop(focused);
            const rootTop = getTop(root);
            const diffBottom = focusTop + getOffsetHeight(focused) - (rootTop + getOffsetHeight(root));
            if (diffBottom <= 0) {
                const diffTop = rootTop - focusTop;
                if (diffTop > 0) {
                    root.scrollTop -= diffTop;
                }
            } else {
                root.scrollTop += diffBottom;
            }
        }
    }
    handleClick = (event, item, index)=>{
        if (!this.props.disabled) {
            if (this.props.onSelect) {
                this.props.onSelect(event, item, index);
            }
        }
    };
    render() {
        const { className, children, selectedIndex, focusedIndex, searchText, onClickOutside, ...other } = this.props;
        const newChildren = Children.map(children, (currentChild, i)=>{
            const focused = focusedIndex === i;
            const optionProps = {
                ref: focused ? (focused)=>{
                    this._focused = focused;
                } : null,
                selected: selectedIndex === i,
                onClick: (e)=>{
                    this.handleClick(e, currentChild, i);
                },
                focused
            };
            return /*#__PURE__*/ cloneElement(currentChild, optionProps);
        }, this);
        return /*#__PURE__*/ React.createElement(ListBox, {
            ref: (root)=>{
                this._root = root;
            },
            className: cx('Select-list', className),
            ...other
        }, newChildren);
    }
}
SelectList.propTypes = {
    /**
	 * Children will be rendered within the `ul` element. And it will get onClick handler
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * If true, onClick will be inactive
	 */ disabled: PropTypes.bool,
    /**
	 * Index of children element, which will be focused
	 */ focusedIndex: PropTypes.number,
    /**
	 * onClick callback
	 * @param {object} event event targeting the element.
	 * @param {object} item child element.
	 * @param {number} index index of child.
	 */ onSelect: PropTypes.func,
    searchText: PropTypes.any,
    /**
	 * Index of children element, which will be selected
	 */ selectedIndex: PropTypes.number,
    /**
	 * additional style
	 */ style: PropTypes.object
};
export { SelectList };
export default onClickOutside(SelectList);
